import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppComponent } from './app.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// PrimeNG Configuration
import { ConfirmationService, MessageService } from 'primeng/api';

import { MaterialModule } from './material.module';
import { CookieService } from 'ngx-cookie-service';

import { TranslateModule } from '@ngx-translate/core';
import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';
registerLocaleData(localeDe, 'de-DE', localeDeExtra);

import { NgChartsModule } from 'ng2-charts';

import { AppRoutingModule } from './app-routing.module';

import { environment } from '@env/environment';
import { CoreModule } from '@core';
import { SharedModule } from '@shared';
import { AuthModule } from '@app/auth';

import { ShellModule } from './shell/shell.module';
import { DashboardModule } from './dashboard/dashboard.module';
import { ReportsModule } from './reports/reports.module';
import { PlaeneModule } from './plaene/plaene.module';
import { DokumenteModule } from './dokumente/dokumente.module';
import { SettingsModule } from './settings/settings.module';

import { AboutModule } from './about/about.module';
import { ImpressumModule } from './impressum/impressum.module';
import { DatenschutzModule } from './datenschutz/datenschutz.module';
import { HelpModule } from './help/help.module';
import { SupportModule } from './support/support.module';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,

    MaterialModule,
    TranslateModule.forRoot(),

    CoreModule,
    SharedModule,
    AuthModule,

    ShellModule,
    DashboardModule,
    ReportsModule,
    PlaeneModule,
    DokumenteModule,
    SettingsModule,

    AboutModule,
    ImpressumModule,
    DatenschutzModule,
    HelpModule,
    SupportModule,

    NgChartsModule,

    AppRoutingModule,
  ],
  providers: [
    {
      provide: LOCALE_ID,
      useValue: 'de-DE',
    },
    CookieService,
    ConfirmationService,
    MessageService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}

